<template>
    <div id="Critical-Shortages" class="wrapper m0-50 critical">
        <div class="section">
            <div class="div-block-15">
                <div class="content4-headline-wrap">
                    <h6><strong class="bold-text-3">Fulfill Outstanding Requests</strong></h6>
                    <div class="size1-text size1-top-clear critical">Requested Supplies</div>
                    <p class="paragraph-73">The following products and services are currently being requested by healthcare professionals, supply manufacturers and product distributers.</p>
                </div>
                <div class="filter-box">
                    <div class="text-block-17">Filters</div>
                    <div class="filter-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form">
                            <div class="filter-dropdown-container">
                                <select id="field" name="field" class="filter-dropdown left-filter w-select"  @change="onProductChange($event)">
                                    <option value="">All Product Categories</option>
                                    <option value="Hand Sanitizer">Hand Sanitizer</option>
<!--                                    <option value="Disposable N95 Masks">Disposable N95 Masks</option>-->
<!--                                    <option value="Disposable Surgical Masks">Disposable Surgical Masks</option>-->
<!--                                    <option value="Eye Protection">Eye Protection</option>-->
<!--                                    <option value="Gowns and Coveralls">Gowns and Coveralls</option>-->
<!--                                    <option value="Nitrile/Vinyl Gloves">Nitrile/Vinyl Gloves</option>-->
<!--                                    <option value="Thermometers">Thermometers</option>-->
                                </select>
                                <select id="field-2" name="field-2" class="filter-dropdown w-select"  @change="onMaterialChange($event)">
                                    <option value="">All Supply Types</option>
                                    <option value="Finished Units">Finished Units</option>
                                    <option value="Ingredients">Ingredients</option>
                                    <option value="Bottles">Bottles</option>
                                    <option value="Caps/Closures/Pumps">Caps/Closures/Pumps</option>
                                    <option value="Labels/Labelling Capacity">Labels/Labelling Capacity</option>
                                    <option value="Packer Boxes">Packer Boxes</option>
                                    <option value="Shipping Boxes">Shipping Boxes</option>
                                    <option value="Manufacturing Capacity">Manufacturing Capacity</option>
                                    <option value="Filling Capacity">Filling Capacity</option>
                                    <option value="Warehousing Capacity">Warehousing Capacity</option>
                                    <option value="Distribution, Shipping or Transportation Capacity">Distribution, Shipping
                                        or Transportation Capacity
                                    </option>
                                    <option value="Regulatory/Legal Services">Regulatory/Legal Services</option>
                                    <option value="Testing/Lab Services">Testing/Lab Services</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="province-filter-container">
                                <label class="province-filter w-radio">
                                    <div id="1" class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='All'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio" id="all-radio" name="radio" value="All" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1">
                                    <span class="province-filter-label all w-form-label">All</span>
                                </label>

                                <label class="province-filter w-radio">
                                    <div id="2" class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='AB'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 3" id="radio-3" name="radio" value="AB" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">AB</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='BC'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 15" id="radio-15" name="radio" value="BC" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">BC</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='MB'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 14" id="radio-14" name="radio" value="MB" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">MB</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='NB'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 13" id="radio-13" name="radio" value="NB" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">NB</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='NL'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 12" id="radio-12" name="radio" value="NL" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">NL</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='NS'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 11" id="radio-11" name="radio" value="NS" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">NS</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='NT'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 10" id="radio-10" name="radio" value="NT" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">NT</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='NU'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 9" id="radio-9" name="radio" value="NU" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">NU</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='ON'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 8" id="radio-8" name="radio" value="ON" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">ON</span>
                                </label>
                                <label
                                        class="province-filter w-radio">
                                    <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                         :class="selectedProvinceVal==='PE'?'w--redirected-checked':''"></div>
                                    <input type="radio" data-name="Radio 7" id="radio-7" name="radio" value="PE" v-on:click="onProvinceChange($event)"
                                           style="opacity:0;position:absolute;z-index:-1"><span
                                        class="province-filter-label w-form-label">PE</span></label><label
                                    class="province-filter w-radio">
                                <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                     :class="selectedProvinceVal==='QC'?'w--redirected-checked':''"></div>
                                <input type="radio" data-name="Radio 6" id="radio-6" name="radio" value="QC" v-on:click="onProvinceChange($event)"
                                       style="opacity:0;position:absolute;z-index:-1"><span
                                    class="province-filter-label w-form-label">QC</span></label><label
                                    class="province-filter w-radio">
                                <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                     :class="selectedProvinceVal==='SK'?'w--redirected-checked':''"></div>
                                <input type="radio" data-name="Radio 5" id="radio-5" name="radio" value="SK" v-on:click="onProvinceChange($event)"
                                       style="opacity:0;position:absolute;z-index:-1"><span
                                    class="province-filter-label w-form-label">SK</span></label><label
                                    class="province-filter w-radio">
                                <div class="w-form-formradioinput w-form-formradioinput--inputType-custom filter-button w-radio-input"
                                     :class="selectedProvinceVal==='YT'?'w--redirected-checked':''"></div>
                                <input type="radio" data-name="Radio 4" id="radio-4" name="radio" value="YT" v-on:click="onProvinceChange($event)"
                                       style="opacity:0;position:absolute;z-index:-1"><span
                                    class="province-filter-label w-form-label">YT</span></label>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="shortages-table">
                    <div class="w-dyn-list">
                        <div v-if="filteredData.length > 0" class="w-dyn-items">
                            <div v-for="(criticalMat, index) in filteredData" :key="criticalMat.id" class="w-dyn-item">
                                <div>
                                    <div data-w-id="0f61cdc8-0f02-cc9b-58cd-fab5413d5096" class="shortage-line-item top-item">
                                        <div class="shortage-product-info">
                                            <div v-on:click="toggleModal(index)" class="div-block-24">
                                                <div class="shortage-product">{{criticalMat.product.description}}</div>
                                                <div class="text-block-8">{{getMaterialName(criticalMat)}}</div>
                                                <div class="div-block-32">
                                                    <div class="more-information-shortage">Requested By: </div>
                                                    <img v-if="criticalMat.user.account.logoUrl" height="18" :src="criticalMat.user.account.logoUrl" :alt="criticalMat.user.account.businessName" class="supplier-logo">
                                                    <div v-if="!criticalMat.user.account.logoUrl" class="more-information-shortage" style="padding-left: 2px">{{criticalMat.user.account.businessName}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="offer-shortage-materials-container">
                                            <div class="shortage-units">{{criticalMat.qtyRequiredNow}} {{getUnits(criticalMat)}}</div>
                                            <a v-on:click="toggleModal(index)" class="offer-shortage-materials w-button">View Request</a>
                                        </div>
                                        <modal v-if="isCriticalMaterialModalOpen && criticalMaterialIndex === index" class="shortage-modal-wrapper" style="opacity: 1; display: flex;">
                                            <div class="modal-background" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d; opacity: 1;">
                                                <div class="modal-title-container">
                                                    <div>
                                                        <div>{{criticalMat.product.description}}</div>
                                                        <div class="modal-header">{{getMaterialName(criticalMat)}}</div>
                                                        <div class="demand-container">
                                                            <div>Requested: </div>
                                                            <div class="shortage-units" style="margin-left: 5px;">{{criticalMat.qtyRequiredNow}} {{getUnits(criticalMat)}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="supplier-information-container">
                                                    <div class="columns-5 w-row">
                                                        <div class="column-9 w-col w-col-6">
                                                            <div class="div-block-27">
                                                                <div class="details-title">Requested by:</div>
                                                                <div class="text-block-10">{{criticalMat.user.account.businessName}}</div>
                                                            </div>
                                                            <div class="div-block-27">
                                                                <div class="details-title">Contact:</div>
                                                                <div class="text-block-10">{{criticalMat.user.firstName}} {{criticalMat.user.lastName}}</div>
                                                            </div>
                                                            <div class="div-block-27">
                                                                <div class="details-title">Contact Email:</div>
                                                                <div class="text-block-10">{{criticalMat.user.email}}</div>
                                                            </div>
                                                            <div class="div-block-27">
                                                                <div class="details-title">Contact Phone:</div>
                                                                <div class="text-block-10">{{criticalMat.user.phoneNumber}}</div>
                                                            </div>
                                                            <div class="div-block-27">
                                                                <div class="details-title">Delivery Location:</div>
                                                                <div class="text-block-10">{{criticalMat.requiredInState}}</div>
                                                            </div>
                                                            <div class="product-files-container">
                                                                <div class="details-title">Related Product Files:</div>
                                                                <span v-if="criticalMat.msdsLink"><a href="#" class="product-file-link">{{criticalMat.msdsLink}}</a></span>
                                                                <span v-if="!criticalMat.msdsLink">N/A</span>
                                                            </div>
                                                            <div class="contact">
                                                                <div class="details-title">Request Description:</div>
                                                                <div class="text-block-10">{{criticalMat.description}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-description-container">
                                                        <div class="w-richtext" v-html="criticalMat.ProductDescription"></div>
                                                    </div>
                                                </div>
                                                <div v-on:click="toggleModal(index)" data-w-id="0f61cdc8-0f02-cc9b-58cd-fab5413d5186" class="close-shortage-modal-button"><img src="../assets/images/close.png" alt=""></div>
                                            </div>
                                        </modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="filteredData.length == 0" class="no-items-found">
                            <div>No items found.</div>
                        </div>
                    </div>
                </div>
                <div v-if="filteredData.length > 0" class="float-right div-block-44">
                    <download-excel
                            class   = "link-blue underline right"
                            :data   = "filteredData"
                            :fields = "csv_fields"
                            type = 'csv'
                            name    = "requested_product.csv">
                        Export Table as csv
                    </download-excel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {listService} from "../assets/js/services/listService";

    export default {
        name: "CriticalInputMaterials",
        data () {
            return {
                isCriticalMaterialModalOpen: false,
                criticalMaterialIndex: undefined,
                criticalMaterials: [],
                filteredData: [],
                filteredDataCopy: [],
                selectedProduct: "",
                selectedMaterial: "",
                selectedProvinceVal: "",
                csv_fields: {
                    'Product Name': 'product.description',
                    'Product Demand': 'product.demandCategory',
                    'Material Name': 'material.materialName',
                    'Material Description': 'material.description',
                    'Material Unit': 'material.unitOfMeasure',
                    'Material Ingredient': 'material.description',
                    'Description': 'description',
                    'Demand Quantity Now': 'qtyRequiredNow',
                    'Demand Quantity in 5 Days': 'qtyRequiredIn5Days',
                    'Address': 'requiredAtStreetAddress',
                    'City': 'requiredInCity',
                    'Province': 'requiredInState',
                    'Postal Code': 'requiredAtPostalCode',
                    'Required File link': 'msdsLink',
                    'Maximum Cost per Unit': 'maximumCostPerUnit',
                    'Other Material Name': 'otherMaterialName',
                    'Comments': 'comments',
                    'Ingredient Delivery Method': 'ingredientDeliveryMethod',
                    'Ingredient Storage': 'ingredientStorage',
                    'Storage Regulatory': 'questionStorageAreaRegulatory',
                    'Finished Unit': 'finishedUnit',
                    'Contact First Name': 'user.firstName',
                    'Contact Last Name': 'user.lastName',
                    'Contact Company': 'user.account.businessName',
                    'Contact Email': 'user.email',
                    'Contact Phone': 'user.phoneNumber'
                },
            }
        },
        created() {
            let _this = this;
            listService.listDemands()
                .then((response) => {
                    this.success = true;
                    _this.criticalMaterials = response.content.content;
                    _this.filteredData =  _this.criticalMaterials;
                    _this.filteredDataCopy = _this.filteredData;
                    _this.selectedProvinceVal = "All";
                })
                .catch(() => {
                    this.fail = true;
                });
        },
        methods: {
            toggleModal: function (index) {
                this.criticalMaterialIndex = index;
                if (this.isCriticalMaterialModalOpen)
                    this.isCriticalMaterialModalOpen = false;
                else
                    this.isCriticalMaterialModalOpen = true;
            },
            getMaterialName: function (request) {
                if (request.material) {
                    return request.material.materialName;
                }
                return request.product ? "Finished Units" : ""
            },
            getRequestId: function (request) {
                return request.id.substr(request.id.length - 8, request.id.length);
            },
            getUnits: function (request) {
                return request.material ? request.material.unitOfMeasure : "units";

            },
            onProductChange: function(event) {
                this.selectedProduct = event.target.value;
                this.filterList();
            },
            onMaterialChange: function(event) {
                this.selectedMaterial = event.target.value;
                this.filterList();
            },
            onProvinceChange: function(event) {
                this.selectedProvinceVal =  event.target.value;
                this.filterList();
            },
            filterList: function() {
                const allProducts = "All Product Categories";
                const allSupply = "All Supply Types";
                if(this.selectedProduct.toLowerCase() === "")
                    this.selectedProduct = allProducts;
                if(this.selectedMaterial.toLowerCase() === "")
                    this.selectedMaterial = allSupply;

                if(this.selectedProduct.toLowerCase() === allProducts.toLowerCase() &&
                    this.selectedMaterial.toLowerCase() === allSupply.toLowerCase() ) {
                    this.filteredData = this.criticalMaterials;
                } else if(this.selectedMaterial.toLowerCase() === allSupply.toLowerCase()) {
                    this.filteredData = this.criticalMaterials.filter((item) => {
                        return item.product.description.toLowerCase() === this.selectedProduct.toLowerCase();
                    });
                }
                else if (this.selectedMaterial.toLowerCase() === "Finished Units".toLowerCase()) {
                    this.filteredData = this.criticalMaterials.filter((item) => {
                        if(this.selectedProduct.toLowerCase() === allProducts.toLowerCase()){
                            return item.finishedUnit === true;
                        } else {
                            return item.product.description.toLowerCase() === this.selectedProduct.toLowerCase() &&
                                item.finishedUnit === true;
                        }
                    });
                }
                else if(this.selectedMaterial.toLowerCase() === "Ingredients".toLowerCase()) {
                    this.filteredData = this.criticalMaterials.filter((item) => {
                        if(this.selectedProduct.toLowerCase() === allProducts.toLowerCase()){
                            return item.material ? item.material.ingredient === true : false;
                        } else {
                            return item.product.description.toLowerCase() === this.selectedProduct.toLowerCase() &&
                                (item.material ? item.material.ingredient === true : false);
                        }
                    });
                }
                else if(this.selectedMaterial.toLowerCase() !== allSupply.toLowerCase()) {
                    this.filteredData = this.criticalMaterials.filter((item) => {
                        if(this.selectedProduct.toLowerCase() === allProducts.toLowerCase()){
                            return item.material ? item.material.materialName.toLowerCase() === this.selectedMaterial.toLowerCase() : false;
                        } else {
                            return item.product.description.toLowerCase() === this.selectedProduct.toLowerCase() &&
                                (item.material ? item.material.materialName.toLowerCase() === this.selectedMaterial.toLowerCase() : false);
                        }
                    });
                }
                this.filteredDataCopy = this.filteredData;
                this.filterProvinces();
            },
            filterProvinces: function() {
                if(this.selectedProvinceVal !== "All") {
                    this.filteredData = this.filteredDataCopy.filter((item) => {
                        return item.requiredInState.toLowerCase().includes(this.selectedProvinceVal.toLowerCase()) || item.requiredInState.toLowerCase() === 'ALL'.toLowerCase();
                    });
                } else {
                    this.filteredData = this.filteredDataCopy;
                }
            }
        }
    }
</script>

<style scoped>

</style>
